import { useEffect, useState } from "react";
import {
  useStripe,
} from "@stripe/react-stripe-js";
import axios from "axios";

import { API, REDIRECTURL } from "../../../backend";
import authHeader from "../../../services/auth-header";
import AuthService from "../../../services/auth.service";

function Confirm() {
  const [pwd, setPassword] = useState("");
  const [message, setMessage] = useState(null);
  const stripe = useStripe();

  const generatePassword = () => {
    const uppercaseLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26)); // Random uppercase letter
    const lowercaseLetters = Array.from({ length: 2 }, () => String.fromCharCode(97 + Math.floor(Math.random() * 26))).join(''); // Random two lowercase letters
    const digits = Math.floor(100 + Math.random() * 900); // Random three-digit number

    const newPassword = uppercaseLetter + lowercaseLetters + '@' + digits;
    setPassword(newPassword);
  };

  useEffect(() => {
    generatePassword();
  }, []);

  const handleSuccess = async (paymentId) => {
    await axios.post(
      API + 'paymentsub/retrieve-payment-intent/', { payment_intent_id: paymentId },
      // 'http://localhost:8000/retrieve-payment-intent/',{ payment_intent_id: paymentId },
      {
        headers: authHeader()
      }
    ).then((response) => {
      if (response.data.success === 1) {
        const name = response.data.payment_intent.metadata.name;
        const email = response.data.payment_intent.metadata.email;
        const password = pwd;
        const company_name = response.data.payment_intent
          .metadata.companyName;
        const address = response.data.payment_intent
          .metadata.address;
        const country = response.data.payment_intent.metadata.country_name
        const state = response.data.payment_intent.metadata.stateName
        const city = response.data.payment_intent.metadata.city;
        const zip_code = response.data.payment_intent.metadata.zipCode;
        const phone_number = response.data.payment_intent.metadata.phoneNumber;
        const plan = response.data.payment_intent.metadata.plan;
        const ipAddress = response.data.payment_intent.metadata.ip_address;
        const userallow = response.data.payment_intent.metadata.userallow
        const start_date = response.data.payment_intent.metadata.start_date
        const end_date = response.data.payment_intent.metadata.end_date
        const sub_total = response.data.payment_intent.metadata.sub_total
        const promotion_code = response.data.payment_intent.metadata.promotion_code
        const renewal_date = response.data.payment_intent.metadata.renewal_date
        const plan_id = response.data.payment_intent.metadata.plan_id
        const amount = response.data.payment_intent.amount
        // const payment_method_type = response.data.payment_intent.metadata.payment_method_type
        AuthService.register(
          name,
          email,
          password,
          company_name,
          address,
          country,
          state,
          city,
          zip_code,
          phone_number,
          plan,
          userallow
        ).then((res) => {
          if (res.data.success === 1) {
            const company = res.data.companyid
            // const body ={
            //   user: res.data.userid,
            //   transaction_id: res.data.transactonid,
            //   payment_id: response.data.response.id,
            //   payment_type: response.data.response.payment_method_types,
            //   mode_of_payment: '',
            //   amount: response.data.response.amount/100,
            //   sub_total: sub_total/100,
            //   tax: 0,
            //   total: response.data.response.amount/100,
            //   status: response.data.response.status,
            //   ip_address: ipAddress,
            //   start_date: start_date,
            //   end_date:end_date,
            //   plan:plan,
            //   updated_at: response.data.response.created
            // }
            axios.post(API + 'paymentsub/subscription/customer/', {
              customer_name: name,
              company_name,
              address,
              city,
              ZIP: zip_code,
              phone_number,
              state,
              country,
              email,
              Status: 'A'
            }, {
              headers: authHeader()
            }
            ).then((res) => {
              if (res.data.success === 1) {
                axios.post(API + 'paymentsub/subscription/', {
                  customer_id: res.data.data.id,
                  company_id: company,
                  plan_id: plan_id,
                  Status: 'A',
                  signup_date: res.data.data.reg_Date,
                  start_date: start_date,
                  end_date: end_date,
                  renewal_date: renewal_date,
                  no_of_users: userallow,
                  intent_id: paymentId,
                  total_amount: amount / 100,
                  promo_code: promotion_code,
                  cancel_date: null
                },
                  {
                    headers: authHeader()
                  }
                ).then((respo) => {
                  if (respo.data.success === 1) {
                    axios.post(API + 'paymentsub/subscription/payment/', {
                      sub_id: respo.data.data.id,
                      payment_date: null,
                      payment_method: '',
                      payment_gateway: '',
                      payment_ref: '',
                      payment_status: 'pending',
                      no_of_user: userallow,
                      total_amount:amount/100
                    },
                      {
                        headers: authHeader()
                      }).then((resData) => {
                        if (resData.data.success === 1) {
                          window.location.replace(REDIRECTURL);
                        } else {
                          console.log('res', res.data.errors)
                        }
                      })
                  } else {
                    console.log('res.data.errors', res.data.errors)
                  }
                })
              } else {
                console.log('res.data.errors', res.data.errors)
              }
            })
            //  axios.post(API + 'accounting/payment/', body,
            //   {
            //     headers: authHeader()
            //   })
            //   .then((responsedata) =>{
            //     if (responsedata.data.success === 1) {
            //       const data={
            //         plan:plan,
            //         start_date :responsedata.data.start_date,
            //         end_date:responsedata.data.end_date,
            //         company:responsedata.data.company
            //       }
            //       const pid = responsedata.data.payment_id
            //       axios.post(API + `accounting/subscriptionpaymentadd/${pid}/`,data, {
            //         headers: authHeader()
            //       })
            //     }

            //   })
          } else {
            console.log('res', res.data.error)
          }
        })
      }else{
        console.log('res', response.data.error)
      }
    })

  }

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }


    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      const paymentId = paymentIntent.id
      handleSuccess(paymentId)
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });



  }, [stripe]);
  return (
    <>
      <div className="container-fluid pt-8">
        <div className="cardsucess bodysucess justify-content-center">
          <div className="divsucess" style={{ height: '100px', width: '100px' }}>
            <i className="checkmark isucess" style={{ lineHeight: '100px', fontSize: '50px', marginLeft: '-7px' }}>✓</i>
          </div>

          <h1 className="hsucess">Your payment success!</h1>
          <p className="psucess">Thank you for your payment. Your transaction has been processed successfully.
            Please check your email for login instructions.</p><br />
        </div>
      </div>
    </>
  );
}

export default Confirm;